
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-co/plataforma",
      function () {
        return require("private-next-pages/es-co/plataforma/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-co/plataforma"])
      });
    }
  